<template>
    <span>
        <InputNumber v-model="val" @on-change="changed" size="small" :min="min" :max="max" :step="step"
            :precision="precision"></InputNumber>
    </span>
</template>
<script>
    export default {
        name: 'de-number-prop',
        props: {
            value: {
                type: Number,
                default: 0,
                timer: null
            },
            min: {
                type: Number,
                default: -Infinity
            },
            max: {
                type: Number,
                default: Infinity
            },
            step: {
                type: Number,
            },
            precision: {
                type: Number
            },
        },
        data() {
            return {
                val: 0
            }
        },
        watch: {
            value: {
                handler(value) {
                    this.val = value;
                },
                immediate: true
            }
        },
        methods: {
            changed() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$emit("input",  this.val)
                    this.$emit('save')
                }, 1000);
            }
        }
    }
</script>